import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-t border-gray-700 p-4 md:p-6 shadow-2xl">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex-1 text-center md:text-left">
          <p className="text-gray-200 text-sm md:text-base">
            Web sitemizde size en iyi deneyimi sunabilmek için çerezler kullanıyoruz. Detaylı bilgi için{' '}
            <Link to="/kvkk" className="text-gray-400 hover:text-gray-300 underline cursor-pointer">
              KVKK
            </Link>
            {' '}ve{' '}
            <Link to="/cerez-politikasi" className="text-gray-400 hover:text-gray-300 underline cursor-pointer">
              Çerez Politikası
            </Link>
            {' '}sayfalarını inceleyebilirsiniz.
          </p>
        </div>
        <button
          onClick={handleAccept}
          className="px-6 py-3 bg-gradient-to-r from-gray-300 via-gray-200 to-gray-400 text-black font-bold rounded-full hover:shadow-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
        >
          Kabul Et
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
